/** Stripe webhooks can settle after checkout returns. Refresh every billing view together. */
export function refreshBillingAfterPayment() {
  const refresh = () => {
    window.dispatchEvent(new Event('genie:balance-changed'))
    window.dispatchEvent(new Event('genie:payment-methods-changed'))
    window.dispatchEvent(new Event('genie:billing-changed'))
  }
  refresh()
  // These bounded refreshes intentionally outlive the payment dialog.
  for (const delay of [1500, 5000, 12000]) window.setTimeout(refresh, delay)
}
